import { Component, OnInit, HostListener, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatSidenav, MatSidenavContent } from '@angular/material';
import { CoreService } from '../core.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})

export class NavComponent implements OnInit {
  windowScrolled: boolean = false;
  @ViewChild('elementoScroll', { static: true }) elementoScroll: MatSidenavContent;

  @ViewChild('sidenav', { static: false }) sidenav: MatSidenav;

  esMovil: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth < 600) {
      this.sidenav.close();
      this.sidenav.mode = 'over';
    } else {
      this.sidenav.open();
      this.sidenav.mode = 'side';
    }
  }

  public startOpen: boolean;

  constructor(private changeDetector: ChangeDetectorRef, private coreService: CoreService) {
  }

  ngOnInit() {
    this.esMovil = this.coreService.isMobile();
  }

  ngAfterViewInit() {
    if (window.innerWidth > 600) {
      this.sidenav.mode = 'side';
      this.sidenav.open();
    }
    this.changeDetector.detectChanges();
  }

  cambiarScroll(data) {
    this.windowScrolled = data;
  }

  backToTop() {
    this.elementoScroll.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
